export interface MappingOrigin {
    strategy: string;
    confidence?: number;
}

export const manualMappingOrigin = (): MappingOrigin => ({ strategy: 'Manual' });
